/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVialPlus: {
  name: 'vial-plus';
  data: string;
} = {
  name: 'vial-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5a.5.5 0 0 0 0 1h.5V13a2.5 2.5 0 0 0 5 0V1.5H8a.5.5 0 0 0 0-1H2Zm1.5 1v3h3v-3h-3Zm0 4h3V13a1.5 1.5 0 0 1-3 0V5.5Zm8.5 0a.5.5 0 0 1 .5.5v1.5H14a.5.5 0 0 1 0 1h-1.5V10a.5.5 0 0 1-1 0V8.5H10a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
